import React from "react"
import { Pressable, View } from "react-native"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { Body, Small } from "@/components/standard/BFText"
import { BFColors } from "@/constants/Colors"
import FolderSimple from "phosphor-react-native/src/icons/FolderSimple"
import ArrowSquareOut from "phosphor-react-native/src/icons/ArrowSquareOut"

interface PortalCardProps {
  onPress?: () => void
  className?: string
}

export const FilePortalCard: React.FC<PortalCardProps> = ({
  onPress,
  className = "",
}) => {
  return (
    <Pressable
      testID={"file-portal-card"}
      onPress={onPress}
      className={`bg-card border border-border rounded-md p-4 ${className}`}
    >
      <Horizontal className="items-center justify-between">
        <Horizontal className="items-center gap-3 flex-1">
          <View className="size-8 items-center justify-center">
            <FolderSimple
              weight={"duotone"}
              size={24}
              color={BFColors.midnightBlue}
            />
          </View>

          <Vertical className="flex-1">
            <Body color="default" className="mb-1">
              Upload documents in Portal
            </Body>
            <Small color="hint">Access our secure document portal</Small>
          </Vertical>
        </Horizontal>
        <ArrowSquareOut size={16} color={BFColors.midnightBlue} />
      </Horizontal>
    </Pressable>
  )
}
